import { render, staticRenderFns } from "./GlyanecPostcard.vue?vue&type=template&id=2d59e1ba&scoped=true&"
import script from "./GlyanecPostcard.vue?vue&type=script&lang=js&"
export * from "./GlyanecPostcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d59e1ba",
  null
  
)

export default component.exports